import axios from "axios";

export const validateOtp = async (data) => {
    let {token, ...payload} = data
    let res = await axios.post('/auth/validate_otp', payload, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
    return res.data;
}

export const setPassword = async (data) => {
    let {token, ...payload} = data
    let res = await axios.post('/auth/set_password', payload, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
    return res.data;
}

export const signIn = async (data, token = null) => {
    let res = await axios.post('/auth/login', data, {
        headers: {
            ...(token && { Authorization: `Bearer ${token}` })
        }
    });
    return res.data;
}


export const signUp = async (data) => {
    let res = await axios.post('/auth/signup', data)
    return res.data; 
}

export const verifyCode = async (data) => {
    let res = await axios.post('/auth/verify_code', data)
    return res.data;
}

export const resendCode = async (data) => {
    let res = await axios.post('/auth/resend_code', data)
    return res.data;
}

export const ssoAuthent = async (data) => {
    let {uuid, ...payload} = data
    let res = await axios.post(`/auth/sso-callback?uuid=${uuid}`, payload)
    return res.data;
}

export const forgotPassword = async (data) => {
    let res = await axios.post('/auth/forgot_password', data)
    return res.data;
}

export const verifyResetOtp = async (data) => {
    let {email, ...payload} = data
    let res = await axios.post(`/auth/verify_reset_password_otp/${email}`, payload)
    return res.data;
}


export const register2fa = async (token) => {
    let res = await axios.get('/auth/register_2fa', {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
    return res.data;
}

export const verify2FaToken = async (data) => {
    let {auth_token, ...payload} = data
    let res = await axios.post('/auth/verify_2fa_token', payload, {
        headers: {
            'Authorization': `Bearer ${auth_token}`
        }
    })
    return res.data;
}

export const requestAccess = async (data) => {
    let res = await axios.post('/auth/request-access', data)
    return res.data;
}

export const exchangeCode = async (data) => {
    let res = await axios.post('/auth/exchange-code', data)
    return res.data;
}

/**
 * ROAR-4988 — BE1: exchanges the signed-in session for a single-use, PKCE-bound handoff code the
 * Siemba MCP redeems server-side, so the JWT never appears in a URL.
 *
 * Contract (Story ROAR-4984 Cross-Repo Contract): Bearer JWT (axios default header);
 * 200 `{ code }` | 4xx/5xx `{ code?, message }` where `code` is one of the backend-owned `MCP_*`
 * values. `return_to` is sent exactly as received — the backend does an exact allow-list match.
 *
 * @param {object} payload
 * @param {string} payload.return_to The MCP callback URL from the `/mcp/authorize` query.
 * @param {string} payload.code_challenge The PKCE S256 challenge from the `/mcp/authorize` query.
 * @returns {Promise<{code: string}>}
 */
export const mcpAuthorizeCode = async ({ return_to, code_challenge }) => {
    const res = await axios.post('/auth/mcp/authorize-code', { return_to, code_challenge })
    return res.data;
}
